import { Link } from 'react-router-dom';
import ConditionsGenerales from '../../components/CGV/CGV';

function Terms() {
  return (
    <section className="mb-3">
      <div className="container">
        <h2> Mentions Légales</h2>
        <p>
          Les présentes conditions générales d’utilisation et de vente s’appliquent aux rapports
          entre les Utilisateurs et moovicar SAS (ci-après « moovicar » ou « nous »), qui édite les
          sites internet fr.moovicar.com, de.moovicar.com, es.moovicar.com, at.moovicar.com,
          be.moovicar.com, no.moovicar.com et moovicar.com, société au capital de 1231552,50€, sise
          au "ADRESSE LOCAL", et enregistrée au R.C.S. de Paris sous le numéro "NUMERO".
          <p>Le Responsable de la publication est M. AZIZ Senni. </p>
          L’hébergement du site est assuré par :<p>Amazon Web Services,</p> Inc. P.O. Box 81226
          Seattle, <p>WA 98108-1226 http://aws.amazon.com</p>{' '}
        </p>
        <p>
          {' '}
          Information de contact et horaires d’ouverture du service client En France, une assistance
          à l’utilisation du Site et des Services est accessible :
          <ul>
            <li>Par email en cliquant ici</li>
          </ul>
        </p>
        <p>
          Informations sur les visiteurs actifs mensuels moyens dans l'Union européenne De octobre
          2023 à mars 2024, au sein de l'Union européenne, notre site web a enregistré en moyenne
          617 840 visiteurs actifs mensuels.
        </p>
        <h2>Conditions Générales d'Utilisation</h2>
        <div className="mb-3">
          <ConditionsGenerales />
        </div>
        <div className="text-center">
          <Link className="btn btn-outline-lg mb-2" to="/help">
            Voir le centre d'aide <i className="bi bi-arrow-right-circle h5"></i>
          </Link>
        </div>
        <hr
          style={{
            border: '1px solid #ff6600',
            width: '100%',
            margin: '20px 0', // Pas de margin auto pour éviter la centration
          }}
        />{' '}
      </div>
    </section>
  );
}

export default Terms;
